// extracted by mini-css-extract-plugin
export default {"card":"BonusCard_card__45Bml","suptitle":"BonusCard_suptitle__6fbgE","title":"BonusCard_title__d0u2z","btn":"BonusCard_btn__9maW3","expired":"BonusCard_expired__OYcT5"};